
    import phoneValidateService from '@/apps/shared/services/phone-service';
    export default {
        data() {
            return {
                formData: {
                    areaCode: '',
                    telephone: '',
                    email: '',
                    validTelephone: '',
                    validEmail: ''
                },
                messageErrorDigits: "",
                messageErrorEmail: "",
            };
        },
        methods: {
            getFormData() {
                return {
                    areaCode: this.formData.areaCode,
                    telephone: this.formData.telephone,
                    email: this.formData.email,
                    validTelephone: this.formData.validTelephone,
                    validEmail: this.formData.validEmail
                };
            },
            setFormData(data) {
                this.formData = { ...data };
            },

            validPhone: function () {
                if (this.formData.telephone == "" && this.formData.areaCode == "") {
                    this.validDigits = true;
                }
                return new Promise<any>(async (resolve) => {
                    this.messageErrorDigits = "";
                    await phoneValidateService.validatePhone(this.formData.areaCode, this.formData.telephone).then(o => {
                        this.messageErrorDigits = o.validCountDigit ? "" : (o.validCountDigit === false ? o.message : "");
                        this.formData.validTelephone = o.validCountDigit;
                        resolve(this.formData.validTelephone);
                    });
                })
            },
            validEmail: function (email) {
                const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                var valid = regex.test(email);
                this.formData.validEmail = valid;
            }
        },
        watch: {
            'formData.areaCode': function (newVal) {
                if (newVal != null && newVal != "") {
                    this.validPhone();
                }
                this.messageErrorDigits = "";
            },
            'formData.telephone': function (newVal) {
                if (newVal != null && newVal != "") {
                    this.validPhone();
                }
                else {
                    this.messageErrorDigits = "";
                }
            },
            'formData.email': function (newVal) {
                if (newVal != null && newVal != "") {
                    this.validEmail(newVal);
                }
                else {
                    this.messageErrorEmail = "";
                }
            }

        }
    };
